module.exports = __webpack_public_path__ + "static/media/user-hex.0a2f85b8.svg";